import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { supabase } from "../../supabaseClient";

/**
 * Guarda de rota para conteúdo exclusivo de famílias aprovadas.
 *
 * Regras:
 *  - Sem sessão → redireciona para /login
 *  - Logado mas não é família (babá, admin) → redireciona para seu dashboard
 *  - Família cadastrada mas não aprovada → redireciona para /aguardando-aprovacao
 *  - Família aprovada → renderiza children
 */
export default function ApprovedFamilyRoute({ children }) {
  const [status, setStatus] = useState("loading");
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;

    (async () => {
      const {
        data: { session },
      } = await supabase.auth.getSession();

      if (!session) {
        if (!cancelled) setStatus("unauthenticated");
        return;
      }

      const { data: usuario } = await supabase
        .from("usuarios")
        .select("tipo, doc_status, status_conta, is_admin")
        .eq("id", session.user.id)
        .maybeSingle();

      if (!usuario) {
        if (!cancelled) setStatus("unauthenticated");
        return;
      }

      // Admins têm acesso total
      if (usuario.is_admin || usuario.tipo === "admin") {
        if (!cancelled) setStatus("ok");
        return;
      }

      const isFamilia =
        usuario.tipo === "cliente" || usuario.tipo === "familia";

      if (!isFamilia) {
        // Babá ou outro tipo não tem acesso à listagem/perfis de babás
        if (!cancelled) setStatus("wrong_type");
        return;
      }

      if (usuario.doc_status === "aprovado" && usuario.status_conta === true) {
        if (!cancelled) setStatus("ok");
      } else {
        if (!cancelled) setStatus("pending");
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  if (status === "loading") return null;

  if (status === "unauthenticated") {
    return <Navigate to="/cadastro-familia" replace state={{ from: location }} />;
  }

  if (status === "pending") {
    return <Navigate to="/aguardando-aprovacao" replace />;
  }

  if (status === "wrong_type") {
    return <Navigate to="/login" replace />;
  }

  return children;
}
